import { useAuth, computeBadge, computeLevel } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Badge } from '@jaylabs/ui';
import { DropdownMenu, DropdownMenuItem, DropdownMenuSeparator } from './DropdownMenu';
import './UserBadgeBar.css';

/**
 * User badge/level display. By default it renders inline and scrolls with the page.
 * Pass fixed=true if you ever want it floating in a fixed position.
 */
function UserBadgeBar({ fixed = false }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  if (!user) return null;

  const points = user?.total_points ?? 0;
  const levelInfo = computeLevel(points);
  const badge = computeBadge(points);

  return (
    <div className={`dd-badge-bar ${fixed ? 'dd-badge-bar-fixed' : ''}`}>
      <div className="dd-vstack dd-gap-1" style={{ alignItems: 'flex-start' }}>
        <DropdownMenu
          trigger={
            <button className="dd-badge-bar-name">
              {user.display_name || user.username}
            </button>
          }
        >
          <DropdownMenuItem onClick={() => navigate('/settings')}>
            👤 Edit Profile
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => navigate('/settings')}>
            ⚙️ Settings
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => navigate('/settings')}>
            🧰 Task Settings (categories/tags/statuses)
          </DropdownMenuItem>
          {user?.email?.toLowerCase() === 'jay@jaylarson.com' && (
            <DropdownMenuItem onClick={() => navigate('/admin/feedback')}>
              🛠️ Admin Panel
            </DropdownMenuItem>
          )}
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={() => { logout(); navigate('/'); }}>
            <span style={{ color: 'var(--dd-red-500)' }}>🚪 Logout</span>
          </DropdownMenuItem>
        </DropdownMenu>
        <div className="dd-hstack dd-gap-2 dd-hstack-wrap">
          <Badge variant="primary">{points} pts</Badge>
          {levelInfo?.label && (
            <Badge variant="info">{levelInfo.label}</Badge>
          )}
          {badge && (
            <Badge variant="secondary">{badge}</Badge>
          )}
        </div>
      </div>
    </div>
  );
}

export default UserBadgeBar;
